import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var THERAPY_TYPE = [{
  label: '減重',
  i18n: 'booking:therapyTypeOptions.weightLoss'
}, {
  label: '糖尿',
  i18n: 'booking:therapyTypeOptions.diabetes'
}, {
  label: '增肌',
  i18n: 'booking:therapyTypeOptions.muscleGain'
}, {
  label: '營養',
  i18n: 'booking:therapyTypeOptions.nutrition'
}, {
  label: '點滴',
  i18n: 'booking:therapyTypeOptions.ivTherapy'
}, {
  label: '特殊方案',
  i18n: 'booking:therapyTypeOptions.specialPlan'
}, {
  label: '網紅方案',
  i18n: 'booking:therapyTypeOptions.influencerPlan'
}, {
  label: '舊客追蹤(入過療程)',
  i18n: 'booking:therapyTypeOptions.existingCustomerWithTherapy'
}, {
  label: '舊客追蹤(未入過療程)',
  i18n: 'booking:therapyTypeOptions.existingCustomerWithoutTherapy'
}, {
  label: '其他',
  i18n: 'booking:therapyTypeOptions.other'
}];

var getStages = function getStages(prefix, count) {
  return Array.from({
    length: count
  }, function (_, index) {
    return {
      label: "".concat(prefix, "-").concat(index + 1)
    };
  });
};

var THERAPY_STAGE = [{
  label: 'X'
}].concat(_toConsumableArray(Array.from({
  length: 20
}, function (_, index) {
  return getStages((index + 1).toString(), 2);
}).flat()), _toConsumableArray(Array.from({
  length: 8
}, function (_, index) {
  return {
    label: "M".concat(index + 1)
  };
})), _toConsumableArray(Array.from({
  length: 6
}, function (_, index) {
  return getStages("R".concat(index + 1), 2);
}).flat()));
var VISIT_PURPOSE = [{
  label: '跨院視訊/在家',
  i18n: 'booking:visitPurposeOptions.crossHospitalTeleconsultationHome'
}, {
  label: '跨院視訊/人來',
  i18n: 'booking:visitPurposeOptions.crossHospitalTeleconsultationVisit'
}, {
  label: '視訊',
  i18n: 'booking:visitPurposeOptions.teleconsultation'
}, {
  label: '新竹視訊',
  i18n: 'booking:visitPurposeOptions.hsinchuTeleconsultation'
}, {
  label: '北屯視訊',
  i18n: 'booking:visitPurposeOptions.beitunTeleconsultation'
}, {
  label: '南屯視訊',
  i18n: 'booking:visitPurposeOptions.nantunTeleconsultation'
}, {
  label: '高雄視訊',
  i18n: 'booking:visitPurposeOptions.kaohsiungTeleconsultation'
}, {
  label: '台北視訊',
  i18n: 'booking:visitPurposeOptions.taipeiTeleconsultation'
}, {
  label: '純拿藥',
  i18n: 'booking:visitPurposeOptions.medicationOnly'
}, {
  label: '營養師諮詢',
  i18n: 'booking:visitPurposeOptions.nutritionistConsultation'
}, {
  label: '運動營養諮詢',
  i18n: 'booking:visitPurposeOptions.sportsNutritionConsultation'
}, {
  label: '心理服務',
  i18n: 'booking:visitPurposeOptions.psychologicalService'
}, {
  label: '藥物衛教',
  i18n: 'booking:visitPurposeOptions.medicationEducation'
}, {
  label: '抽血-檢驗所',
  i18n: 'booking:visitPurposeOptions.bloodTestLab'
}, {
  label: '抽血-跨院',
  i18n: 'booking:visitPurposeOptions.bloodTestCrossHospital'
}, {
  label: '抽血(空腹+留尿)',
  i18n: 'booking:visitPurposeOptions.bloodTestFastingWithUrine'
}, {
  label: '抽血(空腹+不留尿)',
  i18n: 'booking:visitPurposeOptions.bloodTestFastingWithoutUrine'
}, {
  label: '抽血(不需空腹)',
  i18n: 'booking:visitPurposeOptions.bloodTestNonFasting'
}, {
  label: '抽血(OGTT)',
  i18n: 'booking:visitPurposeOptions.bloodTestOGTT'
}, {
  label: '拿管具',
  i18n: 'booking:visitPurposeOptions.getTestTube'
}, {
  label: '交檢體',
  i18n: 'booking:visitPurposeOptions.sampleSubmission'
}, {
  label: 'Embody',
  i18n: 'booking:visitPurposeOptions.embody'
}, {
  label: '經皮雷射',
  i18n: 'booking:visitPurposeOptions.transcutaneousLaser'
}, {
  label: 'HRV/APBC',
  i18n: 'booking:visitPurposeOptions.hrvApbc'
}, {
  label: '打針(藥物)',
  i18n: 'booking:visitPurposeOptions.injectionWithMedication'
}, {
  label: '拆CGM',
  i18n: 'booking:visitPurposeOptions.removeCgm'
}, {
  label: '裝CGM',
  i18n: 'booking:visitPurposeOptions.installCgm'
}, {
  label: '純買商品',
  i18n: 'booking:visitPurposeOptions.purchaseProductOnly'
}, {
  label: '買營養品',
  i18n: 'booking:visitPurposeOptions.purchaseSupplements'
}, {
  label: '量測3D',
  i18n: 'booking:visitPurposeOptions.measure3d'
}, {
  label: '量測Inbody',
  i18n: 'booking:visitPurposeOptions.measureInbody'
}, {
  label: '費用處理退費',
  i18n: 'booking:visitPurposeOptions.processRefund'
}, {
  label: '費用處理尾款',
  i18n: 'booking:visitPurposeOptions.processRemainingPayment'
}, {
  label: '點滴-邁爾氏',
  i18n: 'booking:visitPurposeOptions.ivMyersCocktail'
}, {
  label: '點滴-活力硒',
  i18n: 'booking:visitPurposeOptions.ivVitalSelenium'
}, {
  label: '點滴-消脂',
  i18n: 'booking:visitPurposeOptions.ivFatBurning'
}, {
  label: '點滴-舒壓',
  i18n: 'booking:visitPurposeOptions.ivStressRelief'
}, {
  label: '點滴-抗發炎',
  i18n: 'booking:visitPurposeOptions.ivAntiInflammatory'
}, {
  label: '點滴-腸道修復',
  i18n: 'booking:visitPurposeOptions.ivGutRepair'
}, {
  label: '點滴-肝臟修復',
  i18n: 'booking:visitPurposeOptions.ivLiverRepair'
}, {
  label: '點滴-抗氧化',
  i18n: 'booking:visitPurposeOptions.ivAntioxidant'
}, {
  label: '點滴-美白抗氧化',
  i18n: 'booking:visitPurposeOptions.ivWhiteningAntioxidant'
}, {
  label: '點滴-頂級抗氧化',
  i18n: 'booking:visitPurposeOptions.ivPremiumAntioxidant'
}, {
  label: '點滴-皮膚過敏',
  i18n: 'booking:visitPurposeOptions.ivSkinAllergy'
}, {
  label: '點滴-特調',
  i18n: 'booking:visitPurposeOptions.ivCustomized'
}, {
  label: '初診',
  i18n: 'booking:visitPurposeOptions.initialVisit'
}, {
  label: '初診(減重)(純門診)',
  i18n: 'booking:visitPurposeOptions.firstVisitWeightLossOutpatient'
}, {
  label: '初診(減重)(檢驗)',
  i18n: 'booking:visitPurposeOptions.firstVisitWeightLossExamination'
}, {
  label: '初診(減重)入療程',
  i18n: 'booking:visitPurposeOptions.firstVisitWeightLossTreatment'
}, {
  label: '初診(糖尿)(純門診)',
  i18n: 'booking:visitPurposeOptions.firstVisitDiabetesOutpatient'
}, {
  label: '初診(糖尿)(檢驗)',
  i18n: 'booking:visitPurposeOptions.firstVisitDiabetesExamination'
}, {
  label: '初診(糖尿)入療程',
  i18n: 'booking:visitPurposeOptions.firstVisitDiabetesTreatment'
}, {
  label: '初診(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.firstVisitWithReportTreatment'
}, {
  label: '初診(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.firstVisitWithReportNoTreatment'
}, {
  label: '初診(取消)',
  i18n: 'booking:visitPurposeOptions.firstVisitCancelled'
}, {
  label: '初診(改期)',
  i18n: 'booking:visitPurposeOptions.firstVisitRescheduled'
}, {
  label: '初回診(減重)(純門診)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpWeightLossOutpatient'
}, {
  label: '初回診(減重)(檢驗)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpWeightLossExamination'
}, {
  label: '初回診(減重)入療程',
  i18n: 'booking:visitPurposeOptions.initialFollowUpWeightLossTreatment'
}, {
  label: '初回診(糖尿)(純門診)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpDiabetesOutpatient'
}, {
  label: '初回診(糖尿)(檢驗)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpDiabetesExamination'
}, {
  label: '初回診(糖尿)入療程',
  i18n: 'booking:visitPurposeOptions.initialFollowUpDiabetesTreatment'
}, {
  label: '初回診(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpWithReportTreatment'
}, {
  label: '初回診(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpWithReportNoTreatment'
}, {
  label: '初回診(取消)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpCancelled'
}, {
  label: '初回診(改期)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpRescheduled'
}, {
  label: '回診(減重)(純門診)',
  i18n: 'booking:visitPurposeOptions.followUpWeightLossOutpatient'
}, {
  label: '回診(減重)(檢驗)',
  i18n: 'booking:visitPurposeOptions.followUpWeightLossExamination'
}, {
  label: '回診(減重)續療程',
  i18n: 'booking:visitPurposeOptions.followUpWeightLossContinueTreatment'
}, {
  label: '回診(減重)不續療程',
  i18n: 'booking:visitPurposeOptions.followUpWeightLossDiscontinueTreatment'
}, {
  label: '回診(糖尿)(純門診)',
  i18n: 'booking:visitPurposeOptions.followUpDiabetesOutpatient'
}, {
  label: '回診(糖尿)(檢驗)',
  i18n: 'booking:visitPurposeOptions.followUpDiabetesExamination'
}, {
  label: '回診(糖尿)續療程',
  i18n: 'booking:visitPurposeOptions.followUpDiabetesContinueTreatment'
}, {
  label: '回診(糖尿)不續療程',
  i18n: 'booking:visitPurposeOptions.followUpDiabetesDiscontinueTreatment'
}, {
  label: '回診(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.followUpWithReportTreatment'
}, {
  label: '回診(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.followUpWithReportNoTreatment'
}, {
  label: '回診(取消)',
  i18n: 'booking:visitPurposeOptions.followUpCancelled'
}, {
  label: '回診(改期)',
  i18n: 'booking:visitPurposeOptions.followUpRescheduled'
}, {
  label: '回診看報告',
  i18n: 'booking:visitPurposeOptions.followUpCheckReport'
}, {
  label: '回診拿藥',
  i18n: 'booking:visitPurposeOptions.followUpMedication'
}, {
  label: '回診追蹤成效',
  i18n: 'booking:visitPurposeOptions.followUpTrackingEffectiveness'
}, {
  label: '回診特殊狀況',
  i18n: 'booking:visitPurposeOptions.followUpSpecialCircumstances'
}, {
  label: '初診成長(純門診)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthOutpatient'
}, {
  label: '初診成長(檢驗)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthExamination'
}, {
  label: '初診成長入療程',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthTreatment'
}, {
  label: '初診成長(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthWithReportTreatment'
}, {
  label: '初診成長(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthWithReportNoTreatment'
}, {
  label: '初診成長(取消)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthCancelled'
}, {
  label: '初診成長(改期)',
  i18n: 'booking:visitPurposeOptions.firstVisitGrowthRescheduled'
}, {
  label: '初回診成長(純門診)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthOutpatient'
}, {
  label: '初回診成長(檢驗)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthExamination'
}, {
  label: '初回診成長入療程',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthTreatment'
}, {
  label: '初回診成長(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthWithReportTreatment'
}, {
  label: '初回診成長(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthWithReportNoTreatment'
}, {
  label: '初回診成長(取消)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthCancelled'
}, {
  label: '初回診成長(改期)',
  i18n: 'booking:visitPurposeOptions.initialFollowUpGrowthRescheduled'
}, {
  label: '回診成長(純門診)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthOutpatient'
}, {
  label: '回診成長(檢驗)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthExamination'
}, {
  label: '回診成長續療程',
  i18n: 'booking:visitPurposeOptions.followUpGrowthContinueTreatment'
}, {
  label: '回診成長不續療程',
  i18n: 'booking:visitPurposeOptions.followUpGrowthDiscontinueTreatment'
}, {
  label: '回診成長(有報告)(入療程)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthWithReportTreatment'
}, {
  label: '回診成長(有報告)(未入療程)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthWithReportNoTreatment'
}, {
  label: '回診成長(取消)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthCancelled'
}, {
  label: '回診成長(改期)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthRescheduled'
}, {
  label: '回診成長拿藥',
  i18n: 'booking:visitPurposeOptions.followUpGrowthMedication'
}, {
  label: '回診成長追蹤成效',
  i18n: 'booking:visitPurposeOptions.followUpGrowthTrackingEffectiveness'
}, {
  label: '回診成長特殊狀況',
  i18n: 'booking:visitPurposeOptions.followUpGrowthSpecialCircumstances'
}, {
  label: '保健品方案',
  i18n: 'booking:visitPurposeOptions.healthProductPlan'
}, {
  label: '回診成長(畢業)',
  i18n: 'booking:visitPurposeOptions.followUpGrowthGraduation'
}, {
  label: '回診(減重)(畢業)',
  i18n: 'booking:visitPurposeOptions.followUpWeightLossGraduation'
}, {
  label: '回診(糖尿)(畢業)',
  i18n: 'booking:visitPurposeOptions.followUpDiabetesGraduation'
}];

var getOptions = function getOptions(options) {
  return function (t) {
    return options.map(function (option) {
      return {
        label: option.i18n ? t(option.i18n, option.label) : option.label,
        value: option.label
      };
    });
  };
};

export var getTherapyStageOptions = getOptions(THERAPY_STAGE);
export var getVisitPurposeOptions = getOptions(VISIT_PURPOSE);
export var getTherapyTypeOptions = getOptions(THERAPY_TYPE);

var getText = function getText(t, options, value) {
  var option = options.find(function (item) {
    return item.label === value;
  });
  return option ? t(option.i18n, option.label) : value;
};

export var getVisitPurposeText = function getVisitPurposeText(t, value) {
  return getText(t, VISIT_PURPOSE, value);
};
export var getTherapyTypeText = function getTherapyTypeText(t, value) {
  return getText(t, THERAPY_TYPE, value);
};